import _ from "lodash";
import { useRef, useEffect } from "react";

function deepCompareEquals(a, b) {
  return _.isEqual(a, b);
}

function useDeepCompareMemoize(value) {
  const ref = useRef(value);

  if (!deepCompareEquals(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

export default function useDeepCompareEffect(callback, dependencies) {
  const deps = useDeepCompareMemoize(dependencies);
  useEffect(callback, [deps]);
}
